export default __webpack_public_path__ + "static/img/17.b7117d2.png";